import React, { useState } from 'react';
import EscolaPicker from './EscolaPicker';

function VinculoModal({ show, onClose, onSubmit, form, handleChange, escolas = [], title = 'CADASTRO DE VÍNCULO' }) {
  const [showPicker, setShowPicker] = useState(false);

  if (!show) return null;

  const escolaSelecionada = escolas.find(e => e.cnpj === form.cnpj);

  return (
    <>
      <div className="modal show d-block" tabIndex="-1"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
              <h6 className="modal-title mb-0 small">
                <i className="bi bi-link-45deg me-2"></i>{title}
              </h6>
              <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <form id="vinculo-form" onSubmit={onSubmit}>
                <div className="mb-3">
                  <label className="form-label">Cliente / Entidade *</label>
                  <div className="input-group input-group-sm">
                    <input
                      type="text"
                      className="form-control"
                      value={escolaSelecionada ? `${escolaSelecionada.nome} (${escolaSelecionada.cnpj})` : ''}
                      readOnly
                      placeholder="Clique para selecionar..."
                    />
                    <button
                      type="button"
                      className="btn btn-outline-success"
                      onClick={() => setShowPicker(true)}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                  </div>
                  <input type="hidden" name="cnpj" value={form.cnpj} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Tipo de Vínculo *</label>
                  <select className="form-select form-select-sm" name="tipo" value={form.tipo} onChange={handleChange} required>
                    <option value="">Selecione...</option>
                    <option value="ADMIN">ADMINISTRADOR</option>
                    <option value="GEST">GESTOR</option>
                    <option value="USER">USUÁRIO</option>
                  </select>
                </div>
              </form>
            </div>
            <div className="modal-footer" style={{ padding: '0.4rem 1rem' }}>
              <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>Cancelar</button>
              <button type="submit" form="vinculo-form" className="btn btn-success btn-sm">Salvar</button>
            </div>
          </div>
        </div>
      </div>
      <EscolaPicker
        show={showPicker}
        escolas={escolas}
        selectedCnpj={form.cnpj}
        onSelect={e => { handleChange({ target: { name: 'cnpj', value: e.cnpj } }); setShowPicker(false); }}
        onClose={() => setShowPicker(false)}
      />
    </>
  );
}

export default VinculoModal;
